// src/App.js
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { Routes, Route } from 'react-router-dom';
import Shop from './Pages/Shop';
import ShopCat from './Pages/ShopCat';
import Product from './Pages/Product';
import Footer from './Components/Footer/Footer';
import goat_banner from './Components/Assets/banner-goat.jpg'
import cow_banner from './Components/Assets/banner-cow.jpg'
import sheep_banner from './Components/Assets/banner-sheep.jpg'
import camel_banner from './Components/Assets/banner-camel.jpg'
import LoginSignup from './Pages/LoginSignup';
import CartItems from './Components/cartItems/CartItems';
import MpesaModal from './Components/MpesaModal/MpesaModal';

function App() {
  return (
    <div>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Shop/>}/>
        <Route path='/Goats' element={<ShopCat banner={goat_banner} category="Goats"/>}/>
        <Route path='/Sheeps' element={<ShopCat banner={sheep_banner} category="Sheeps"/>}/>
        <Route path='/Cows' element={<ShopCat banner={cow_banner} category="Cows"/>}/>
        <Route path='/Camels' element={<ShopCat banner={camel_banner} category="Camels"/>}/>
        <Route path='/Product' element={<Product/>}/>
        <Route path='/Product/:productId' element={<Product/>}/>
        <Route path='/cart' element={<CartItems/>}/>
        <Route path='/Login' element={<LoginSignup/>}/>
        <Route path='/OrderPayment' element={<MpesaModal/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;